import { AcrResponse, CompanyProfitCalculationPack, PredictionCompanyResponse, VectorResponse } from '../common/dto';
import SftAuthService from './SftAuthService';
import SftPortfolioService from './SftPortfolioService';
import { ChartData } from '@/domain/types';

export default class SftRecommendService {
  public static ApplicationPath = window.ApplicationPath;
  private isGuest = true;
  constructor(private auth: SftAuthService) {}

  public calculateProfit(symbol: number, startAmount: number, displayHistory: boolean) {
        return this.postCorsJSON<CompanyProfitCalculationPack>('CalculateProfit',
            {symbol, startAmount, displayHistory});
  }

  public getACR(Group?: number, Sgroup?: number) {
    const o = { Group: Group ? Group : -1, Sgroup: Sgroup ? Sgroup : -1 };
    return this.postCorsJSON<AcrResponse>('GetACR', o);
  }
  public getRecommendations(load: boolean) {
    const o = { load };
    // return this.postCorsJSON<PredictionCompanyResponse>('GetRecommendations?load=' + load, o);
    return this.postCorsJSON<PredictionCompanyResponse>('GetRecommendations?load=' + load + '', o);
  }
  public getVector() {
    // var o = {Group,Sgroup}
    return this.postCorsJSON<VectorResponse>('GetVector');
  }
  // add them to common requests objs
  private addSessionParams(obj: any) {
    const t = this.auth.getSessionParams();
    obj.sessionid = t.sessionid;
    obj.loggedin = t.loggedin;
    return obj;
  }

  public PredictCompany(symbol: string, period: number, timezoneOffset: number) {
    return this.postCorsJSON<ChartData>('PredictCompany', { symbol, period, timezoneOffset });
  }

  private postCorsJSON<T>(method: string, params: object | null = null): Promise<T> {
    // const d = $.Deferred();
    return new Promise((resolve, reject) => {
      const request = new XMLHttpRequest();

      request.open('POST', window.ApplicationPath + '/WebServices/WebService.asmx/' + method, true);
      request.setRequestHeader('Accept', 'application/json');
      request.setRequestHeader('Content-Type', 'application/json; charset=utf-8');
      request.withCredentials = true;
      // tslint:disable-next-line:only-arrow-functions
      request.onload = function() {
        if (request.status >= 200 && request.status < 400) {
          // Success!
          const data = JSON.parse(request.responseText);
          if (data.d.error) {
            reject();
          } else {
            resolve(data.d);
          }
        } else {
          // We reached our target server, but it returned an error
          reject();
        }
      };

      // tslint:disable-next-line:only-arrow-functions
      request.onerror = function() {
        reject();
      };
      if (params) {
        request.send(JSON.stringify(params));
      } else {
          request.send();
      }
    });
    //
    // ($.ajax as any)({
    //     type: 'POST',
    //     cache: false,
    //     data: params?JSON.stringify(params):null,
    //     url: SftPortfolioService.ApplicationPath + '/WebServices/WebService.asmx/' + method,
    //     contentType: 'application/json; charset=utf-8',
    //     dataType: "json",
    //     crossDomain: true,
    //     xhrFields: {withCredentials: true},
    //     success: (data:any, textStatus:any, jqXHR:any)=> {
    //         if (data.d.error) d.reject(); else d.resolve(data.d);
    //     },
    //     error: ()=>{
    //         d.reject();
    //     }
    // });
    // return d.promise() as JQueryPromise<T>;
  }
}
